/** @jsx jsx */
import { jsx } from '@emotion/react';
import { connectPagination } from 'react-instantsearch-dom';
import { Pagination } from '../Pagination';

export default connectPagination(({ currentRefinement, ...rest }) => (
  <Pagination currentPage={currentRefinement} {...rest} />
));
